import PropTypes from 'prop-types';
import YouTube from '@u-wave/react-youtube';

const YoutubePlayer = ({ slide, playing, setPlaying, siteId }) => {
  const { url } = slide;

  let youtubeLang = 'sv';
  switch (siteId) {
    case 11:
      youtubeLang = 'da';
      break;
    case 3:
      youtubeLang = 'no';
      break;
    case 15:
      youtubeLang = 'fi';
      break;
    default:
      break;
  }

  return (
    <YouTube
      className="gw-gallery__youtube"
      video={url}
      paused={!playing}
      modestBranding
      showInfo={false}
      showRelatedVideos={false}
      onPlaying={() => setPlaying(true)}
      lang={youtubeLang}
    />
  );
};

YoutubePlayer.propTypes = {
  slide: PropTypes.shape({
    url: PropTypes.string,
    type: PropTypes.string,
  }),
  playing: PropTypes.bool,
  setPlaying: PropTypes.func,
  siteId: PropTypes.number.isRequired,
};

YoutubePlayer.defaultProps = {
  slide: PropTypes.shape({
    url: '',
  }),
  playing: false,
  setPlaying: () => null,
};

export default YoutubePlayer;
